import { render, staticRenderFns } from "./Detail-pantau.vue?vue&type=template&id=37c4ee0a"
import script from "./Detail-pantau.vue?vue&type=script&lang=js"
export * from "./Detail-pantau.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports